import Vue from "vue";

export default {
  mentees() {
      return Vue.http.get('mentor/mentees');
  }
};